const accTitle = document.querySelectorAll('.accordion-title');

const toggleAccordion = (e) => {
	const target = e.currentTarget.parentNode;

	for (let sibling of target.closest('.accordion-wrapper').children) {
		if (!target.classList.contains('active')) {
			sibling.classList.remove('active');
		}
	}
	target.classList.toggle('active');
}

accTitle.forEach(a => a.addEventListener('click', toggleAccordion));
